import { useState } from 'react';
import { Bubble } from '../components/Bubble';
import { useAuth } from '../state/auth';

export function LoginScreen() {
  const signIn = useAuth((s) => s.signIn);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const run = async () => {
    setBusy(true);
    setError(null);
    try {
      await signIn();
    } catch {
      setError('Sign-in did not finish. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="hero-bg" data-testid="login">
      <Bubble style={{ padding: 32, maxWidth: 420, textAlign: 'center' }}>
        <div style={{ fontSize: 84 }} aria-hidden="true">🔮</div>
        <h1 className="t-display" style={{ margin: '8px 0' }}>EthrHunt</h1>
        <p>
          Scan the world around you.
          <br />
          Find what the Ethr left behind.
        </p>
        <button type="button" className="btn filled" style={{ marginTop: 28 }} disabled={busy} onClick={() => void run()}>
          {busy ? <span className="spinner" /> : '➜'} {busy ? 'Signing in…' : 'Continue with Google'}
        </button>
        {error && <p role="alert" style={{ marginTop: 16, color: '#b3261e', fontWeight: 700 }}>{error}</p>}
      </Bubble>
    </div>
  );
}
